import styled from "@emotion/styled";
import type { FC } from "react";
import React, { useState } from "react";
import envVariables from "src/lib/envVariables";
import RxDietCubit from "src/state/RxDietCubit/RxDietCubit";
import { useBloc } from "src/state/state";
import { DisableAppPadding } from "../AppRouter/AppRouter";
import { LoadingIndicator } from "../Loader/Loader";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  inset: 0;

  @media screen and (max-width: 729px) {
    top: var(--safe-area-top, 43px);
    bottom: calc(var(--safe-area-inset-bottom, 0px) + 56px);
  }

  @media screen and (min-width: 730px) {
    top: calc(var(--safe-area-inset-top, 0px) + 64px);
    bottom: 0;
  }
`;

const StyledIframe = styled.iframe`
  outline: none;
  border: none;
  width: 100%;
  height: 100%;
  flex: 1;
  display: block;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-cream);
  z-index: 1;
`;

const RxDietIframe: FC = () => {
  const [, { messageEventListener }] = useBloc(RxDietCubit);
  const [isLoading, setIsLoading] = useState(true);

  const iframeUrl = envVariables.RXDIET_IFRAME_URL;

  React.useEffect(() => {
    window.addEventListener("message", messageEventListener);

    return () => {
      window.removeEventListener("message", messageEventListener);
    };
  }, [messageEventListener]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <PageContainer>
      <DisableAppPadding />
      {isLoading && (
        <LoadingOverlay>
          <LoadingIndicator />
        </LoadingOverlay>
      )}
      <StyledIframe
        src={iframeUrl}
        id="rxdiet-app"
        title="RxDiet Nutrition Program"
        onLoad={handleIframeLoad}
      />
    </PageContainer>
  );
};

export default RxDietIframe;
